import api from '@/services/api';
import type { ConfigSetting } from '@/features/products/types/products.types';
import type { SettingValue } from '../utils/smriqPlanDefaults';

const smrPath = '/smr';

export interface SmriqDurationDefaults {
    min: number;
    max: number;
}

export const fetchSmriqDurationDefaults = async (): Promise<SmriqDurationDefaults> => {
    const { data } = await api.get<{ data: SmriqDurationDefaults }>(`${smrPath}/smriq/duration-defaults`);
    return { min: data.data.min, max: data.data.max };
};

/** Group write: a present key is a create/update, an absent key is a delete,
 *  applied atomically by the backend in one transaction. */
export const saveSmriqPlanDefaults = async (
    productId: string,
    defaults: Record<string, SettingValue>,
): Promise<ConfigSetting[]> => {
    const { data } = await api.put<{ data: ConfigSetting[] }>(
        `${smrPath}/products/${productId}/plan-defaults`,
        defaults,
    );
    return data.data;
};
